import { Option } from "../../components/options/types";

export const SEARCH_ROUTES_OPTIONS: Array<Option<string>> = [
  {
    title: "جستجو چک",
    value: "/search",
  },
  {
    title: "جستجو فاکتور",
    value: "/search/factor",
  },
  {
    title: "جستجو نقدی",
    value: "/search/cash",
  },
];
